/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { createContext, useContext } from "react";
import { useForm } from "react-hook-form";
import { HandleForms } from "../HandleForms";
import { formContext } from "../../routes/routes";
import { useParams } from "react-router-dom";
export const watchContext = createContext();

export const FormOnAFly = ({ children, submit, setSchema, indication, index, lastIndex, array, hide, editPage }) => {
  let params = useParams();
  const savedData = JSON.parse(localStorage.getItem(params.applicationID)) || {};
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    unregister,
    clearErrors,
  } = useForm({
    criteriaMode: "all",
    defaultValues: savedData,
  });
  React.useEffect(() => {
    const subscription = watch((value) => {
      const values = JSON.parse(localStorage.getItem(params.applicationID)) || {};
      const isFileValue = (v) =>
        v instanceof File || (Array.isArray(v) && v.some((f) => f instanceof File));

      const filteredFormValues = Object.fromEntries(
        Object.entries(value).filter(([, fieldValue]) => fieldValue !== undefined && !isFileValue(fieldValue))
      );

      const preservedFileDisplay = {};
      Object.keys(values).forEach((key) => {
        if (key.includes("filedisplay") || key.includes("[")) {
          preservedFileDisplay[key] = values[key];
        }
      });

      const mergedValues = {
        ...values,
        ...filteredFormValues,
        ...preservedFileDisplay,
      };
    Object.keys(mergedValues).forEach((key) => {
        if (key.endsWith("filedisplay")) {
        const baseKey = key.replace("filedisplay", "");
        const files = mergedValues[key];

        if (Array.isArray(files)) {
          files.forEach((file, index) => {
            if (file.name) {
              mergedValues[`${baseKey}[${index}]`] = `${params.applicationID}_${file.name}`;
            }
          });
        }
      }
    });
      localStorage.setItem(params.applicationID + "lastModifiedOn", new Date());
      localStorage.setItem(params.applicationID, JSON.stringify(mergedValues));
    });
    return () => subscription.unsubscribe();
  }, [params.applicationID, watch]);

  const schemaContext = useContext(formContext);

  const changeFunction = (name, e) => {
    let data = {
      [name]: e,
    };
    let values = JSON.parse(localStorage.getItem(params.applicationID));
    if (values) {
      values = { ...values, ...data };
      localStorage.setItem(params.applicationID, JSON.stringify(values));
      console.log("Local storage updated");
    } else {
      localStorage.setItem(params.applicationID, JSON.stringify(data));
      console.log("Local storage updated");
    }
  };
  const w = watch();

  // if(w["RailRoad line transverse"] === undefined || w["Railroad Milestone MP"] === undefined){
  //   var existing = JSON.parse(localStorage.getItem(params.applicationID));
  //   if (existing !== null) {
  //     if(existing["RailRoad line transverse"] && w["RailRoad line transverse"] === undefined){
  //       w["RailRoad line transverse"]= existing["RailRoad line transverse"];
  //     }
  //     if(existing["Railroad Milestone MP"] && w["Railroad Milestone MP"] === undefined){
  //       w["Railroad Milestone MP"]= Number(existing["Railroad Milestone MP"]);
  //     }
  //   }
  // }

  const fun = () => {};
  let radioKey = (localStorage.getItem("renderKeyRadio") && localStorage.getItem("renderKeyRadio").split(",")) || [];
  let checkKey = (localStorage.getItem("renderKeyCheckBox") && localStorage.getItem("renderKeyCheckBox").split(",")) || [];
  let hideKey = (localStorage.getItem("hideKey") && localStorage.getItem("hideKey").split(",")) || [];

  let checkArray = checkKey.map((c) => Number(c));
  let radioArray = radioKey.map((r) => Number(r));
  let hideK = hideKey.map((k) => Number(k));
  let user;
  for (var i = 0; i < radioArray.length; i++) {
    user = radioArray[i];
    if (checkArray.indexOf(user) >= 0) {
      let schema = schemaContext.schema.sections.map((sec) => {
        if (sec.label === "Applicant's Checklist") {
          sec.questions.map((question) => {
            if (question.id === user) {
              question.hide = false;
            }
          });
        }
        return sec;
      });
    }
  }
  let hides;
  if (hideKey) {
    for (var i = 0; i < radioArray.length; i++) {
      hides = radioArray[i];
      if (checkArray.indexOf(hides) >= 0) {
        schemaContext.schema.sections.map((sec) => {
          if (sec.label === "Applicant's Checklist") {
            sec.questions.map((question) => {
              if (question.id === hides) {
                question.hide = true;
              }
            });
          }
          return sec;
        });
      }
    }
  }

  return (
    <>
      <form
        //onSubmit={handleSubmit((data) => submit(data, index))}
        onSubmit={handleSubmit((data) => {
          window.scrollTo(0, 0);
          return submit(data, index);
        })}
        className="" //d-flex flex-column align-items-center
      >
        <watchContext.Provider value={w}>
          <HandleForms
            setSchema={setSchema}
            children={children}
            register={register}
            unregister={unregister}
            errors={errors}
            clearErrors={clearErrors}
            watch={watch}
            changeFunction={changeFunction}
            editPage={editPage}
          />
        </watchContext.Provider>

        <div className="d-flex justify-content-center">
          <button type="submit" className="btn btn-primary btn-lg mt-4" disabled={index + 1 === lastIndex && array.includes(0)}>
            {/* {indication ? (
              <>
                {" "}
                <span
                  className="spinner-grow spinner-grow-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Submitting...{" "}
              </>
            ) : ( */}

            <>{editPage ? "save" : index + 1 === lastIndex ? "Submit Application" : "Next Step"} </>
            {/* )} */}
          </button>
        </div>
      </form>
    </>
  );
};
